import { useLocation } from 'react-router-dom'
import { useBilling } from '@/hooks/useBilling'
import { UpgradePage } from '@/pages/billing/UpgradePage'

interface BillingGuardProps {
  orgId: string
  orgSlug: string
  children: React.ReactNode
}

/**
 * Wraps org/product page content. Shows the paywall instead of children
 * when the org's trial has expired and there is no active subscription.
 * The billing page itself is always exempt so users can subscribe.
 */
export function BillingGuard({ orgId, orgSlug, children }: BillingGuardProps) {
  const { isExpired, isLoading } = useBilling(orgId)
  const { pathname } = useLocation()

  // Always allow access to the billing page so users can upgrade
  const isBillingPage = pathname.endsWith('/billing')

  // Don't flash the paywall while the billing status is loading
  if (isLoading || isBillingPage) return <>{children}</>
  if (isExpired) return <UpgradePage orgId={orgId} orgSlug={orgSlug} />

  return <>{children}</>
}
